import Icon from '../components/Icon.vue'

Icon.register({
  poll: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M400 32c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h352zM160 368v-128c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zM256 368v-224c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zM352 368v-64c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/poll.js
// module id = 1654
// module chunks = 0